const acho = document.querySelectorAll(".js-ac");

  function acToggle() {
    const content = this.nextElementSibling;// next js-ac element
    content.classList.toggle("is-open");
    const acho = this; // js-ac in variable
    acho.classList.toggle('is-open');
  }

  for (let i = 0; i < acho.length; i++) {
    acho[i].addEventListener("click", acToggle);
  }